<template>
    <md-select v-model="itemId" :disabled="disabled" :name="name"
        :id="id" @md-opened="onOpenSelect()" @input="pickOptions(itemId)" @md-selected="mdSelect"
        @md-closed="clearFilter()">
        <div class="filterBox" v-if="list.length > 4">
        <input v-model="filter" type="text" ref="inputFilter"
            class="form-control filter" placeholder="Wyszukaj...">
        </div>
        <template v-for="item in filterMethod">
            <slot :item="item" />
        </template>
    </md-select>
</template>

<script>
export default {
name: 'SelectWithFilter',
props: {
    list: {
        type: [Array, Object],
        required: true
    },
    disabled: {
        type: Boolean,
        default: false
    },
    name: {
        type: String,
        default: ''
    },
    id: {
        type: String,
        default: ''
    },
    value: {
        type: [String, Number],
        default: ''
    },
},
computed: {
    filterMethod() {
        let filter = this.filter.trim().toLowerCase();
        if (filter === '') return this.arrayOfContent;
        return this.arrayOfContent.filter(item => item.name.toLowerCase().indexOf(filter) > -1)
    },
},
data: () => ({
    filter: '',
    itemId: '',
    arrayOfContent: [],
}),
methods: {
    pickOptions(item){
        this.$emit('input', item);
    },
    mdSelect(value){
        this.$emit('mdselect', value)
    },
    onOpenSelect(){
        this.$refs.inputFilter.focus()
    },
    clearFilter(){
        this.filter = ''
    }
  },
  mounted(){
    this.arrayOfContent = this.list
    this.itemId = this.value
    this.$watch(() => this.value, newValue => {
            if(typeof newValue === Object)
                this.itemId = newValue.valueId
             else
                this.itemId = newValue
        });
    this.$watch(() => this.list, newValue => {
            this.arrayOfContent = newValue
        });
  }
}
</script>

<style scoped lang="scss">
    .filterBox{
      position: sticky;
      display: block;
      z-index: 3;
      top: 0;
      width: 100%;
      height: 45px;
      background: rgba(255, 255, 255, 1) !important;
      padding: 5px 10px 0px 10px;
    }
    .filter{
      padding: 8px;
      border: none;
      border-bottom: 1px solid black;
      font-size: 15px;
      width: 100%;
    }
</style>
